import { MentionsSearchResponseModel } from '../../../api/mentions/model/mentions-search-response.model';


export class ReportSeriesSearchResult {
    currentPeriodResults: MentionsSearchResponseModel;
    previousPeriodResults: MentionsSearchResponseModel;

    clone() {
        const newResult = new ReportSeriesSearchResult();
        if (this.currentPeriodResults) {
            newResult.currentPeriodResults = JSON.parse(JSON.stringify(this.currentPeriodResults));
        }

        if (this.previousPeriodResults) {
            newResult.previousPeriodResults = JSON.parse(JSON.stringify(this.previousPeriodResults));
        }

        return newResult;
    }
}
